export default "__VITE_ASSET__D1u5xCd___"